import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "lp-wave-content" }
const _hoisted_2 = { class: "lp-wave-login ly-row ly-center-center" }
const _hoisted_3 = { class: "ly-col ly-center-center callback-wrapper" }
const _hoisted_4 = { class: "callback-card lp-load-fadein" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "key" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "raw" }

import { ref, onMounted } from 'vue'

interface Param {
  key: string
  value: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallbackView',
  setup(__props) {

const queryParams = ref<Param[]>([])
const fullUrl = ref('')

onMounted(() => {
  fullUrl.value = window.location.href

  // Parse query string
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.forEach((value, key) => {
    queryParams.value.push({ key, value })
  })
})

return (_ctx: any,_cache: any) => {
  const _directive_load_fade_in = _resolveDirective("load-fade-in")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", null, "OAuth Callback", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "subtitle" }, "Received redirect payload", -1)),
          (queryParams.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Query Parameters", -1)),
                _createElementVNode("table", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Key"),
                      _createElementVNode("th", null, "Value")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(queryParams.value, (param) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: param.key
                      }, [
                        _createElementVNode("td", _hoisted_6, _toDisplayString(param.key), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(param.value), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!queryParams.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("p", { class: "empty" }, "No parameters received.", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Raw URL", -1)),
            _createElementVNode("code", null, _toDisplayString(fullUrl.value), 1)
          ])
        ], 512), [
          [_vShow, true]
        ])
      ])), [
        [_directive_load_fade_in, { delay: 0, timeBetween: 0 }]
      ])
    ])
  ]))
}
}

})